import React from "react";
import { Card, Tooltip, Progress, Button, Tag, Collapse } from "antd";

export default function LeaderboardPanel({
  isDark,
  topScores,
  allScores,
  bottomScores,
  lowAll,
  fullAll,
  showAllLow,
  setShowAllLow,
  showAllFull,
  setShowAllFull,
}) {
  const renderLeaderboards = () => (
    <>
      <div className="podium-grid" style={{ marginTop: 4 }}>
        {topScores.slice(0, 3).map((q, idx) => (
          <Card
            key={`podium-${q.ward}`}
            className={isDark ? "luxe-dark-bg medal-card" : "medal-card"}
            style={{ padding: 12, background: isDark ? undefined : "#fff" }}
          >
            <div className="medal-rank">{idx === 0 ? "🥇" : idx === 1 ? "🥈" : "🥉"}</div>
            <div className="medal-ward" style={{ color: isDark ? "#f5f5f5" : "#111" }}>
              Ward {q.ward}
            </div>
            <Tooltip
              color={isDark ? "#14141b" : "#fff"}
              title={
                <div style={{ maxWidth: 320, color: isDark ? "#f5f5f5" : "#111" }}>
                  <div style={{ fontWeight: 700, marginBottom: 4 }}>Why</div>
                  <div>A single Quality Score ranks wards fairly by rewarding verified (Matched) and active (Alive) records.</div>
                  <div style={{ fontWeight: 700, margin: "8px 0 4px" }}>How</div>
                  <div>Score = 70% × Match Rate + 30% × Alive Rate. Wards marked "N/A" are excluded. All rates obey current filters.</div>
                </div>
              }
            >
              <div className="medal-score" style={{ color: "#d4af37" }}>
                {q.score}%
              </div>
            </Tooltip>
            <Progress percent={q.score} showInfo={false} strokeColor={idx === 0 ? "#d4af37" : idx === 1 ? "#c0c0c0" : "#cd7f32"} trailColor="#23232c" />
            <div className="medal-meta" style={{ color: isDark ? "#cbd5e1" : "#475569" }}>
              Match {q.matchRate}% · Alive {q.aliveRate}%
            </div>
          </Card>
        ))}
      </div>

      {allScores.length > 3 && (
        <div className="podium-grid" style={{ marginTop: 12 }}>
          {allScores.slice(3, 10).map((q, i) => (
            <Card
              key={`podium-${q.ward}-lower`}
              className={isDark ? "luxe-dark-bg medal-card" : "medal-card"}
              style={{ padding: 12, background: isDark ? undefined : "#fff" }}
            >
              <div className="medal-rank">#{i + 4}</div>
              <div className="medal-ward" style={{ color: isDark ? "#f5f5f5" : "#111" }}>
                Ward {q.ward}
              </div>
              <Tooltip
                color={isDark ? "#14141b" : "#fff"}
                title={
                  <div style={{ maxWidth: 320, color: isDark ? "#f5f5f5" : "#111" }}>
                    <div style={{ fontWeight: 700, marginBottom: 4 }}>Why</div>
                    <div>A single Quality Score ranks wards fairly by rewarding verified (Matched) and active (Alive) records.</div>
                    <div style={{ fontWeight: 700, margin: "8px 0 4px" }}>How</div>
                    <div>Score = 70% × Match Rate + 30% × Alive Rate. Wards marked "N/A" are excluded. All rates obey current filters.</div>
                  </div>
                }
              >
                <div className="medal-score" style={{ color: "#d4af37" }}>
                  {q.score}%
                </div>
              </Tooltip>
              <Progress percent={q.score} showInfo={false} strokeColor="#d4af37" trailColor="#23232c" />
              <div className="medal-meta" style={{ color: isDark ? "#cbd5e1" : "#475569" }}>
                Match {q.matchRate}% · Alive {q.aliveRate}%
              </div>
            </Card>
          ))}
        </div>
      )}

      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginTop: 12 }}>
        {(showAllLow ? lowAll : bottomScores).map((q) => (
          <Card
            key={`low-${q.ward}`}
            className={isDark ? "luxe-dark-bg" : ""}
            style={{ flex: "1 1 200px", padding: 12, background: isDark ? undefined : "#fff" }}
          >
            <div style={{ color: isDark ? "#f5f5f5" : "#111", fontWeight: 600, fontSize: 16, marginBottom: 4 }}>
              Ward {q.ward}
            </div>
            <div style={{ color: "#ff6666", fontSize: 24, fontWeight: 700 }}>{q.score}%</div>
            <Progress percent={q.score} showInfo={false} strokeColor="#ef4444" trailColor="#23232c" />
            <div style={{ fontSize: 12, color: "#ccc" }}>
              Match: {q.matchRate}% · Alive: {q.aliveRate}%
            </div>
          </Card>
        ))}
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
        <Button size="small" className="luxe-btn" onClick={() => setShowAllLow((v) => !v)} style={{ padding: "0 14px" }}>
          {showAllLow ? "See less" : `See all below 100% (${lowAll.length})`}
        </Button>
      </div>

      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginTop: 12 }}>
        {(showAllFull ? fullAll : fullAll.slice(0, 5)).map((q) => (
          <Card
            key={`full-${q.ward}`}
            className={isDark ? "luxe-dark-bg" : ""}
            style={{ flex: "1 1 200px", padding: 12, background: isDark ? undefined : "#fff" }}
          >
            <div style={{ color: isDark ? "#f5f5f5" : "#111", fontWeight: 600, fontSize: 16, marginBottom: 4 }}>
              Ward {q.ward}
            </div>
            <div style={{ color: "#d4af37", fontSize: 24, fontWeight: 700 }}>{q.score}%</div>
            <Progress percent={q.score} showInfo={false} strokeColor="#d4af37" trailColor="#23232c" />
            <div style={{ fontSize: 12, color: "#ccc" }}>
              Match: {q.matchRate}% · Alive: {q.aliveRate}%
            </div>
          </Card>
        ))}
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
        <Button size="small" className="luxe-btn" onClick={() => setShowAllFull((v) => !v)} style={{ padding: "0 14px" }}>
          {showAllFull ? "See less" : `See all 100% (${fullAll.length})`}
        </Button>
      </div>
    </>
  );

  return (
    <div style={{ marginTop: 0, marginBottom: 16 }}>
      <Collapse className="insights-collapse" bordered={false} defaultActiveKey={["leaderboard"]}>
        <Collapse.Panel
          header={<span style={{ fontWeight: 700, color: isDark ? "#f5f5f5" : "#111" }}>Leaderboard</span>}
          key="leaderboard"
          showArrow
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "4px 0 10px" }}>
            <Tag color={isDark ? "gold" : "gold"} style={{ color: "#111", fontWeight: 700 }}>
              GAMIFIED
            </Tag>
            <span style={{ color: isDark ? "#f5f5f5" : "#111" }}>
              Podium shows the top three wards by Quality Score. List ranks the next best performers. Tiles below show lowest and perfect wards. All scores obey your current filters.
            </span>
          </div>
          <div className="score-explainer" style={{ display: "flex", alignItems: "flex-start", gap: 8, margin: "0 0 10px" }}>
            <Tag color={isDark ? "gold" : "gold"} style={{ color: "#111", fontWeight: 700 }}>
              SCORE
            </Tag>
            <span style={{ color: isDark ? "#f5f5f5" : "#111" }}>
              <strong>Why:</strong> to compare wards with one fair metric that prioritises verified beneficiaries and active records.{" "}
              <strong>How:</strong> <em>Quality Score = 70% × Match Rate + 30% × Alive Rate</em>. Wards with "N/A" are excluded. All percentages reflect your current filters.
            </span>
          </div>
          {renderLeaderboards()}
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}
